import slotdays from 'api/definitions/slotdays';
import { handleGenericNetworkError } from 'api/actions/handle-generic-network-error';
import { SlotGridType } from 'api/definitions/slotdates/types';
import { SlotDaysResponse } from 'api/definitions/slotdays/types';
import { FulfilmentType, SlotTypes } from 'constants/fulfilmentTypes';
import { SET_SLOTS_DISABLED, SLOT_DAYS } from 'redux/modules/slots/actions/types';
import { flattenSlots } from 'redux/modules/slot-booking/utils/merge-slots';

export const getSlots =
  ({
    fulfilmentType,
    postcode,
    addressId,
    branchId,
    fromDate,
    size,
    slotGridType,
  }: {
    fulfilmentType: FulfilmentType;
    postcode?: string;
    addressId?: string;
    branchId: string;
    fromDate: string;
    size?: number;
    slotGridType?: SlotGridType;
  }) =>
  (dispatch: WtrDispatch) => {
    const { slotType } = fulfilmentType;

    return dispatch({
      types: SLOT_DAYS.triplet,
      apiCall: slotdays.getSlots({
        fromDate,
        size,
        slotType,
        slotGridType,
        ...(slotType === SlotTypes.DELIVERY ? { addressId, postcode } : { branchId }),
        iHandleStatusCodes: [307, 400],
      }),
      callback: {
        success: (data: SlotDaysResponse) => {
          return {
            slots: flattenSlots(data, branchId),
            greenVariant: data.variant,
          };
        },
        failure(e: unknown) {
          let error = new Error(
            'Slot orchestration call succeeded but returned no data or an unknown error',
          );
          if (typeof e === 'object' && e !== null && 'status' in e) {
            if (e.status === 307) {
              return dispatch({
                type: SET_SLOTS_DISABLED,
              });
            }
            if (e.status === 400 && 'message' in e) {
              error = new Error(
                JSON.stringify([
                  {
                    message: e.message,
                    type: 'VALIDATION_ERROR',
                  },
                ]),
              );
            }
          }
          return handleGenericNetworkError({ dispatch, error });
        },
      },
    });
  };
